const apiUrl = process.env.REACT_APP_API_URL;
export const GetAlumnesProjecte = async (id_projecte: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/alumnes`);
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        }
        return [];
    } catch (error) {
        console.log('Error al obtener los datos:', error);
        return [];
    }
};
